import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { SessionService } from '../services/session.service';

const UNAUTHORIZED = 401;

export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const user = inject(SessionService);

  return next(req).pipe(
    catchError((error) => {
      if ([UNAUTHORIZED].includes(error.status)) {
        user.clearSession();
      }

      return throwError(() => error);
    })
  );
};
